import { render, staticRenderFns } from "./detail-diff.vue?vue&type=template&id=39ff5e19"
import script from "./detail-diff.vue?vue&type=script&lang=js"
export * from "./detail-diff.vue?vue&type=script&lang=js"
import style0 from "./detail-diff.vue?vue&type=style&index=0&id=39ff5e19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports